export const BUY_NOW_LOWER_HARD_CAP_FEATURE_FLAG =
  'cnl_buy_now_lower_hard_cap_feature_flag';

export const BUY_NOW_HPPM_FOR_UNRESTRICTED =
  'se_buy_now_expose_hppm_whitelisted';
export const BUY_NOW_NEW_MESSAGES = 'se_buy_now_new_messages';
export const BUY_NOW_EXPOSE_HPPM = 'se_buy_now_expose_hppm';
export const FAST_LANE_CANCELLED = 'fast_lane_cancelled';
export const REOFFER_RP_HARD_CAPS = 'seller-resubmission-reoffer-rp-hard-caps';
export const GREAT_VALUE_BADGE = 'se_buy_now_badges';
export const CNL_AUTO_TOGGLE_UPDATE_PRESET_FEATURE_FLAG =
  'cnl_auto_toggle_update_preset';

export const LOG_SELLER_ADDRESS_SUGGESTIONS = 'lot_seller_address_suggestions';

export const SELLER_INVOICES_PAGE = 'seller-invoices-page';
